import IconContext from './components/IconContext';
export * from './icons';
export { default } from './components/IconDefault';
export { default as createFromIconfontCN } from './components/IconFont';
var IconProvider = IconContext.Provider;
export { IconProvider };
